import actions from './actions';

const { setApp } = actions;

export default {
  setApp,
};
